/**
 * *****************************************************
 */
export class DateValue {
    constructor(dateObj) {
        this.dateObj = dateObj;
    }
}
